<!-- Loading overlay (only visible when isLoading is true) -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<!-- Main Content (Hidden when isLoading is true) -->
<div *ngIf="!isLoading">
  <div id="main-content"></div>

  <!-- Breadcrumb on the left -->
  <nav aria-label="breadcrumb" class="px-5 mb-0">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page">Workspaces</li>
    </ol>
  </nav>

  <div class="d-flex flex-column align-items-center">
    <!-- Centered text -->
    <p class="fs-5 mb-2 text-center">All Workspaces</p>

    <!-- Left-aligned button under the text -->
    <button 
      class="btn btn-primary align-self-start ms-5 mb-3"
      data-bs-toggle="modal" 
      data-bs-target="#confirmationModal">
      Refresh tenant
    </button>

    <!-- Result Message -->
  <div *ngIf="resultMessage" class="result-message">
    {{ resultMessage }}
  </div>
  </div>

  <div *ngIf="workspaces.length > 0; else noWorkspaces">
    <ul *ngFor="let workspace of workspaces">
      <div class="card">
        <div class="card-body d-flex align-items-center justify-content-between p-3">
          <div>
            <a 
              [routerLink]="['/workspace', workspace.id]" 
              class="card-title text-primary fs-5 text-decoration-none">
              {{ workspace.displayName }}
            </a>
            <p class="card-text">Assigned capacity: 
              <a [routerLink]="['/capacity', workspace.capacityId]" class="text-decoration-none">
                {{ workspace.capacityName }}
              </a>
            </p>
          </div>
          <button 
            class="btn btn-outline-primary me-2"
            data-bs-toggle="modal" 
            data-bs-target="#accessModal"
            (click)="onShowWorkspaceAccess(workspace.id)">
            Show workspace access
          </button>
          <i 
            class="bi bi-star float-left"
            (click)="toggleFavorite(workspace)"
            [ngClass]="{'text-warning': workspace.fav}"  
            style="cursor: pointer;">
          </i>
        </div>
      </div>
    </ul>
  </div>

  <ng-template #noWorkspaces>
    <p>No workspaces available.</p>
  </ng-template>

  <!-- Refresh Modal -->
  <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationModalLabel">Refresh tenant</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to perform this action? <br>
          This will take a long time.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>
          <button 
            type="button" 
            class="btn btn-danger" 
            (click)="onButtonClick()"
            data-bs-dismiss="modal">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  

  <!-- Workspace Access Modal -->
  <div class="modal fade" id="accessModal" tabindex="-1" aria-labelledby="accessModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title" id="accessModalLabel">Workspace Access</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <p class="mb-3 text-muted">Below is the list of accounts who have access to this workspace:</p>
          <div class="list-group">
            <div *ngFor="let singleWorkspaceAccess of workspaceAccess" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-1">{{ singleWorkspaceAccess.displayName }}</h6>
                <p class="mb-0 text-muted small">{{ singleWorkspaceAccess.emailAddress }}</p>
              </div>
              <span class="badge badge-custom">{{ singleWorkspaceAccess.principalType }}</span>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div> <!-- End of Main Content Wrapper -->

<!-- CSS -->
<style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .result-message {
    margin-top: 10px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .badge-custom {
    background-color: white;
    border: 1px solid #343a40; /* Dark border */
    color: #343a40; /* Dark text */
    padding: 0.35em 0.65em;
    font-size: 0.85em;
    border-radius: 0.25rem;
  }
</style>
